import { getLang } from "./i18n";
export const TZ = "America/Aruba";
const DAYS = {
  nl: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
  en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
};

const parts = (iso) => {
  const p = {};
  new Intl.DateTimeFormat("en-GB", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short", hour12: false })
    .formatToParts(new Date(iso)).forEach((x) => (p[x.type] = x.value));
  return p;
};

export const fmtTime = (iso) => { const p = parts(iso); return `${p.hour === "24" ? "00" : p.hour}:${p.minute}`; };
export const weekdayIndex = (iso) => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(parts(iso).weekday);
export const fmtDayName = (iso, lang = getLang()) => (DAYS[lang] || DAYS.nl)[weekdayIndex(iso)];
export const fmtDate = (iso) => { const p = parts(iso); return `${p.day}-${p.month}-${p.year}`; };
export const fmtDayTime = (start, end, lang = getLang()) => `${fmtDayName(start, lang)} · ${fmtTime(start)}${end ? ` – ${fmtTime(end)}` : ""}`;
export const fmtFull = (iso, lang = getLang()) => `${fmtDayName(iso, lang)} ${fmtDate(iso)} · ${fmtTime(iso)}`;
export const money = (amount, currency = "AWG") => `${currency} ${Number(amount || 0).toLocaleString("nl-NL", { minimumFractionDigits: Number(amount) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
export const weekdayNames = (lang = getLang()) => [1, 2, 3, 4, 5, 6, 0].map((i) => (DAYS[lang] || DAYS.nl)[i]);
export const monthLabel = (m, lang = getLang()) => {
  const [y, mo] = m.split("-").map(Number);
  return new Date(Date.UTC(y, mo - 1, 15)).toLocaleDateString(lang === "en" ? "en-GB" : "nl-NL", { month: "long", year: "numeric" });
};
